import { GridApi } from 'ag-grid-community';
import React, { ReactElement } from 'react';
import { useIntl } from 'react-intl';
import { CustomContextMenuContainer } from 'tacho-ui';
import './styles.scss';
import { getDefaultGridContextMenuItems } from '../../../core/helpers/aggrid';
import StatusBar from '../AgGrid/StatusBar/StatusBar';

export interface AgGridContextMenuWrapperProps {
    gridApi: GridApi | undefined;
    children: ReactElement<any>;
    showStatusBar?: boolean;
}

function AgGridContextMenuWrapper(props: AgGridContextMenuWrapperProps) {
    const { gridApi, showStatusBar, children } = props;
    const { formatMessage } = useIntl();

    return (
        <CustomContextMenuContainer
            items={getDefaultGridContextMenuItems(formatMessage, gridApi)}
            className={showStatusBar ? 'status-bar-placeholder' : 'h-100'}
        >
            <>
                {children}
                {showStatusBar && <StatusBar gridApi={gridApi} />}
            </>
        </CustomContextMenuContainer>
    );
}

export default AgGridContextMenuWrapper;
